<style scoped>
.mini {
  max-width: 75px;
  min-width: 75px;
}
.short {
  max-width: 140px;
  min-width: 140px;
}
.medium {
  max-width: 220px;
  min-width: 220px;
}
.long {
  max-width: 300px;
  min-width: 300px;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import { SasSelect } from '@/core/ui';

@Component
export default class AppSelect extends SasSelect {
  /**
   * 拡張設定
   * api: オプション値を取得するAPIのURL
   */
  @Prop({required: false})
  options;

  /**
   * 拡張設定
   */
  @Prop({required: false, type: Boolean})
  readonly;

  /**
   * 画面表示されたタイミングで展開されてしまうので一旦無効にします
   * ※入力文字による絞り込みを有効にした場合に発生（仕訳等）
   */
  get autofocus () {
    return false;
  }

  /**
   * デフォルトサイズ
   */
  get defaultSize () {
    return 'medium';
  }

  // クラス
  get customClass () {
    let optionClass = (this.options && 'class' in this.options) ? this.options.class : [this.defaultSize];
    if (this.computedReadonly) {
      if (!Array.isArray(optionClass)) {
        optionClass = [optionClass];
      }
      optionClass.push('is-readonly');
    }
    return optionClass;
  }

  /**
   * readonly
   */
  get computedReadonly () {
    // プロパティ優先
    if (this.readonly === true || this.readonly === 'true') {
      return true;
    }
    const readonly = (this.options && 'readonly' in this.options) ? this.options.readonly : false;
    return readonly;
  }

  /**
   * disabled
   * SasSelectではcomputedDisabledではなくisDisabled
   */
  get isDisabled () {
    // SasSelectの内部状態
    if (this.innerDisabled) {
      return true;
    }

    // プロパティ優先
    if (this.disabled === true || this.disabled === 'true') {
      return true;
    }
    const disabled = (this.options && 'disabled' in this.options) ? this.options.disabled : false;
    return disabled || this.computedReadonly;
  }

  /**
   * 選択値のクリア可否
   * オーバーライド
   */
  get clearable () {
    return (this.options && 'clearable' in this.options) ? this.options.clearable : true;
  }

  /**
   * フィルター可否
   * オーバーライド
   */
  get filterable () {
    return (this.options && 'filterable' in this.options) ? this.options.filterable : false;
  }

  /**
   * 選択オプションを取得する
   * 選択オプションは、options.url で指定されたAPIから取得する。
   */
  fetchOptionsImpl () {
    let fetchPromise = null;
    if (this.options.static !== undefined && this.options.static !== null) {
      // 静的
      const staticResult = {
        data: {
          results: {
            list: this.options.static
          }
        }
      };
      fetchPromise = Promise.resolve().then(() => staticResult);
    } else {
      // API呼出
      const cache = (this.options.global) ? this.$_sas.$cache.global : this.$_sas.$cache;
      const url = this.options.api;
      fetchPromise = cache.segment(url).get(null, () => {
        return this.$_sas.$api.cancel().get(url);
      });
    }

    return fetchPromise.then(response => {
      let options = [];

      // データ変換
      if ('filter' in this.options) {
        options = this.options.filter(response.data.results);
      } else {
        options = response.data.results.list;
      }

      // 選択値追加
      if ('before-options' in this.options) {
        options.unshift(...this.options['before-options']);
      }
      if ('after-options' in this.options) {
        options.push(...this.options['after-options']);
      }

      return options;
    });
  }

  onBlur (...args) {
    this.$emit('app-event', 'blur', this, ...args);

    // フォーカスが外れたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }

  onChange (...args) {
    this.$emit('app-event', 'change', this, ...args);

    // 値が変更されたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }

  onFocus (...args) {
    // フォーカス時にプルダウンが自動展開しないよう修正
    this.$refs.select.visible = false;

    this.$emit('app-event', 'focus', this, ...args);
  }

  // エンターキーイベント
  onEnterKey (event) {
    try {
      // プルダウンが展開中はイベント無視
      if (this.$el.querySelector('.el-input').classList.contains('is-focus')) {
        return;
      }
    } catch (e) { return; }

    // プルダウンの展開を行わずに
    // アプリケーションイベントを発火して元のイベントの伝播は停止する
    this.$emit('app-event', 'enterkey', event, this);
    try {
      event.preventDefault();
      event.stopPropagation();
    } catch (e) {}
  }

  // クリックイベント
  onClick (event) {
    // フォーカス時にプルダウンが自動展開しないよう修正したのでクリック時には展開するよう明示的に指定
    if (this.$refs.select.disabled) {
      return;
    }
    if (this.$el.querySelector('.el-input').classList.contains('is-focus')) {
      return;
    }
    this.$refs.select.visible = true;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/select/AppSelect.vue